import { render, staticRenderFns } from "./passRate.vue?vue&type=template&id=e56ec404&scoped=true&"
import script from "./passRate.vue?vue&type=script&lang=js&"
export * from "./passRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56ec404",
  null
  
)

export default component.exports